import React from 'react'
import axios from 'axios'
import { API_BASE_URL, LAMBDA_BASE_URL } from "../../../constants";
import { getDomainId } from 'utils/utils';
import { getDomainIdSync } from 'utils/utils';



const ExportQ = ({ searchQuery = "", filename = "export.csv", startDate, endDate}) =>{
    const escapeCSV = (value) => {
        if (value == null) return "";
        const cleaned = String(value)
        .replace(/<br\s*\/?>/gi, " ")
        .replace(/[\r\n]+/g, " ")
        .trim();
        return `"${cleaned.replace(/"/g, '""')}"`;
    };

    const exportToCSV = async () => {
        try {
            const domainId= getDomainIdSync();
            const res = await axios.get(`${LAMBDA_BASE_URL}/unanswered-questions`, {
                params :{
                    search : searchQuery,
                    limit : 10000,
                    page : 1,
                    start_date : startDate,
                    end_date : endDate
                },
                headers : {
                    'DOMAIN-TOKEN' :domainId
                }
            });
            const data = res?.data?.result.unanswered_questions || []
            // console.log("data to export", data)
            if (!Array.isArray(data) || data.length === 0){
        
                alert("No data to export");
                return ;
            }
            const headers = ["question","ip_address","created_at"]
            const csvRows = [headers.join(",")]
            data.forEach((row) => {
                const values = headers.map((h) => escapeCSV(row[h]))
                csvRows.push(values.join(","))
            })
            
            const csvString = "\uFEFF" + csvRows.join("\n")
            const blob = new Blob([csvString], { type : "text/csv;charset=utf-8"});
            const url = window.URL.createObjectURL(blob)
            const a =  document.createElement("a");
            a.href = url;
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(url)
        } catch (error) {
            console.error("export failed:", error)
            
            alert("export failed")
        }
    };

    return (
        <button onClick = {exportToCSV}
                 style={{
            padding: "10px 12px",
            borderRadius: "6px",
            background: "#219297",
            color: "white",
            border: "none",
            cursor: "pointer",
            fontSize: "14px",
            maxWidth: "100%",
            boxShadow:
              "-2px 0 4px rgba(0,0,0,0.05), 2px 0 4px rgba(0,0,0,0.05), 0 2px 6px rgba(0,0,0,0.1)",
            fontWeight: "600",
            transition: "filter 0.3s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.filter = "brightness(1.1)")}
          onMouseLeave={(e) => (e.currentTarget.style.filter = "brightness(1)")}
        >
            Export to CSV
        </button>
    )
}
export default ExportQ;